export enum UserSettings {
  SignRequestsPageSize = 'signRequestsPageSize',
  ScanRequestsPageSize = 'scanRequestsPageSize',
  ClientUsersPageSize = 'clientUsersPageSize',
  ClientGroupsPageSize = 'clientGroupsPageSize',
  CustomersPageSize = 'customersPageSize',
  CustomersTraceLogsPageSize = 'customersTraceLogsPageSize',
  SignRequestsTableColumns = 'signRequestsTableColumns_',
  SignRequestNameTitle = 'signrequest-name-title',
  SelectedLanguage = 'language',
  DateFormat = 'dateFormat',
}
